<div class="mainCard">
    <!-- Header with back button and title -->
    <div class="pageHeader">
        <button class="backBtn" (click)="goBack()">
            <img src="../../../../../assets/images/backBtnArrow.svg" alt="back" />
        </button>
        <h1>{{ isEditMode ? moduleDetails.moduleName : 'Create New Module' }}</h1>
    </div>

    <!-- Module Metadata Row (only in edit mode) -->
    <div class="metadataRow" *ngIf="moduleDetails">
        <div class="metaItem">
            <span class="metaLabel">Module:</span>
            <span class="metaValue">{{ moduleDetails.moduleType | titlecase }}</span>
        </div>
        <div class="metaItem">
            <span class="metaLabel">Created by:</span>
            <span class="metaValue">{{ moduleDetails.createdBy }}</span>
        </div>
        <div class="metaItem">
            <span class="metaLabel">Created on:</span>
            <span class="metaValue">{{ moduleDetails.createdOn }}</span>
        </div>
        <div class="metaItem">
            <span class="metaLabel">Updated by:</span>
            <span class="metaValue">{{ moduleDetails.updatedBy }}</span>
        </div>
        <div class="metaItem">
            <span class="metaLabel">Updated on:</span>
            <span class="metaValue">{{ moduleDetails.updatedOn }}</span>
        </div>
        <div class="metaItem statusToggle">
            <span class="metaLabel">Status:</span>
            <label class="toggle">
                <input type="checkbox" [formControl]="$any(moduleForm.get('status'))">
                <span class="slider"></span>
                <span class="toggleLabel">{{ moduleForm.get('status')?.value ? 'Active' : 'Inactive' }}</span>
            </label>
        </div>
    </div>

    <form [formGroup]="moduleForm">
        <!-- Section 1: Module Details For User -->
        <div class="formSection">
            <h2 class="sectionTitle">Module Details For User</h2>
            
            <div class="formGrid threeCol">
                <div class="formGroup">
                    <app-lib-multi-select
                        [labelText]="'Module Type'"
                        [noLabel]="false"
                        [isReq]="true"
                        [options]="moduleTypeOptions"
                        [selectedItems]="selectedModuleType()"
                        [isDropdownOpen]="openDropdownKey === 'moduleType'"
                        (toggleDropdown)="onMultiSelectDropdownToggle('moduleType')"
                        (selectionChange)="onModuleTypeSelectionChange($event)"
                    ></app-lib-multi-select>
                </div>
                <div class="formGroup">
                    <label class="formLabel label required">Module Name</label>
                    <input type="text" class="inputElement" formControlName="moduleName" placeholder="Type here">
                </div>
                <div class="formGroup">
                    <label class="formLabel label required">Module Owner's email</label>
                    <input type="email" class="inputElement" formControlName="moduleOwnerEmail" placeholder="Type here">
                </div>
            </div>

            <div class="formGroup fullWidth">
                <div class="labelRow">
                    <label class="formLabel label required">
                        Module Brief
                    </label>
                    <img src="../../../../../assets/images/infoIcon.svg" alt="info" style="position: absolute; top: -2px; right: 0">
                </div>
                <textarea 
                    class="textareaElement" 
                    formControlName="moduleBrief" 
                    placeholder="Type here"
                    rows="3"
                    [maxlength]="briefCharLimit"
                ></textarea>
                <span class="charCount">{{ getBriefCharCount() }}/{{ briefCharLimit }}</span>
            </div>

            <div class="formGroup fullWidth">
                <div class="labelRow">
                    <label class="formLabel label required">
                        Module Description
                    </label>
                    <img src="../../../../../assets/images/infoIcon.svg" alt="info" style="position: absolute; top: -2px; right: 0">
                </div>
                <textarea 
                    class="textareaElement" 
                    formControlName="moduleDescription" 
                    placeholder="Type here"
                    rows="3"
                    [maxlength]="descriptionCharLimit"
                ></textarea>
                <span class="charCount">{{ getDescriptionCharCount() }}/{{ descriptionCharLimit }}</span>
            </div>

            <!-- Module Features -->
            <div class="formGroup fullWidth">
                <div class="labelRow">
                    <label class="formLabel label required">Module Features</label>
                    <button type="button" class="clearAllBtn" (click)="clearAllFeatures()">Clear All</button>
                </div>
                <div class="featuresList" formArrayName="moduleFeatures">
                    <div class="featureRow" *ngFor="let feature of features.controls; let i = index">
                        <span class="rowNumber">{{ i + 1 }}.</span>
                        <input 
                            type="text" 
                            class="inputElement" 
                            [formControlName]="i" 
                            placeholder="Enter feature"
                        >
                        <button type="button" class="deleteRowBtn" (click)="removeFeature(i)">
                            <img src="../../../../../assets/images/delete.svg" alt="delete">
                        </button>
                    </div>
                </div>
                <div class="addRowSection" style="margin-top: 1rem;">
                    <span>Add more rows:</span>
                    <input type="number" [(ngModel)]="featureRowsToAdd" [ngModelOptions]="{standalone: true}" min="1" max="20" class="rowCountInput">
                    <button type="button" class="addBtn" (click)="addMultipleFeatures()">ADD</button>
                </div>
            </div>
        </div>

        <!-- Divider -->
        <hr class="sectionDivider">

        <!-- Section 2: Module Configuration -->
        <div class="formSection fullWidth">
            <h2 class="sectionTitle">Module Configuration</h2>
            
            <div class="formGrid fourCol">
                <div class="formGroup">
                    <label class="formLabel label required">Module Link</label>
                    <input type="text" class="inputElement" formControlName="moduleLink" placeholder="Type here">
                </div>
                <div class="formGroup">
                    <label class="formLabel label required">Module Image Path</label>
                    <input type="text" class="inputElement" formControlName="moduleImagePath" placeholder="Type here">
                </div>
                <div class="formGroup">
                    <label class="formLabel label">Module Api Link</label>
                    <input type="text" class="inputElement" formControlName="moduleApiLink" placeholder="Type here">
                </div>
                <div class="formGroup">
                    <label class="formLabel label">Module Identity Token</label>
                    <input type="text" class="inputElement" formControlName="moduleIdentityToken" placeholder="Type here">
                </div>
            </div>

            <div class="formGrid fourCol">
                <div class="formGroup">
                    <label class="formLabel label">Module Callback Endpoint</label>
                    <input type="text" class="inputElement" formControlName="moduleCallbackEndpoint" placeholder="Type here">
                </div>
                <div class="formGroup">
                    <label class="formLabel label">Report</label>
                    <input type="text" class="inputElement" formControlName="report" placeholder="Type here">
                </div>
                <div class="formGroup">
                    <label class="formLabel label">Group</label>
                    <input type="text" class="inputElement" formControlName="group" placeholder="Type here">
                </div>
                <div class="formGroup">
                    <label class="formLabel label">Additional Group</label>
                    <input type="text" class="inputElement" formControlName="additionalGroup" placeholder="Type here">
                </div>
            </div>

            <div class="formGrid fourCol">
                <div class="formGroup">
                    <app-lib-multi-select
                        [labelText]="'Business Line'"
                        [noLabel]="false"
                        [isReq]="false"
                        [options]="businessLineOptions"
                        [selectedItems]="selectedBusinessLine()"
                        [isDropdownOpen]="openDropdownKey === 'businessLine'"
                        (toggleDropdown)="onMultiSelectDropdownToggle('businessLine')"
                        (selectionChange)="onBusinessLineSelectionChange($event)"
                    ></app-lib-multi-select>
                </div>
                <div class="formGroup">
                    <label class="formLabel label">Category</label>
                    <input type="text" class="inputElement" formControlName="category" placeholder="Type here">
                </div>
                <div class="formGroup">
                    <label class="formLabel label">Function</label>
                    <input type="text" class="inputElement" formControlName="function" placeholder="Type here">
                </div>
                <div class="formGroup">
                    <label class="formLabel label">Product Line</label>
                    <input type="text" class="inputElement" formControlName="productLine" placeholder="Type here">
                </div>
            </div>

            <div class="formGrid fourCol">
                <div class="formGroup">
                    <app-lib-multi-select
                        [labelText]="'Region'"
                        [noLabel]="false"
                        [isReq]="false"
                        [options]="regionOptions"
                        [selectedItems]="selectedRegion()"
                        [isDropdownOpen]="openDropdownKey === 'region'"
                        (toggleDropdown)="onMultiSelectDropdownToggle('region')"
                        (selectionChange)="onRegionSelectionChange($event)"
                    ></app-lib-multi-select>
                </div>
                <div class="formGroup">
                    <label class="formLabel label">Role Name</label>
                    <input type="text" class="inputElement" formControlName="roleName" placeholder="Type here">
                </div>
                <div class="formGroup">
                    <label class="formLabel label">Tag Id</label>
                    <input type="text" class="inputElement" formControlName="tagId" placeholder="Type here">
                </div>
            </div>

            <!-- Toggle switches -->
            <div class="formGrid fourCol">
                <div class="toggleGroup">
                    <label class="formLabel label">Is Internal ?</label>
                    <div class="toggleSwitch">
                        <span [class.active]="!moduleForm.get('isInternal')?.value">No</span>
                        <label class="switch">
                            <input type="checkbox" formControlName="isInternal">
                            <span class="sliderRound"></span>
                        </label>
                        <span [class.active]="moduleForm.get('isInternal')?.value">Yes</span>
                    </div>
                </div>
                <div class="toggleGroup">
                    <label class="formLabel label">Is Multimodal ?</label>
                    <div class="toggleSwitch">
                        <span [class.active]="!moduleForm.get('isMultimodal')?.value">No</span>
                        <label class="switch">
                            <input type="checkbox" formControlName="isMultimodal">
                            <span class="sliderRound"></span>
                        </label>
                        <span [class.active]="moduleForm.get('isMultimodal')?.value">Yes</span>
                    </div>
                </div>
                <div class="toggleGroup">
                    <label class="formLabel label">Instant Processing ?</label>
                    <div class="toggleSwitch">
                        <span [class.active]="!moduleForm.get('instantProcessing')?.value">No</span>
                        <label class="switch">
                            <input type="checkbox" formControlName="instantProcessing">
                            <span class="sliderRound"></span>
                        </label>
                        <span [class.active]="moduleForm.get('instantProcessing')?.value">Yes</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Divider -->
        <hr class="sectionDivider">

        <!-- Section 3: Action Configuration -->
        <div class="formSection fullWidth">
            <h2 class="sectionTitle">Action Configuration</h2>
            
            <div class="actionConfigTable">
                <div class="tableHeader">
                    <div class="thCol actionCol">ACTION ALLOWED</div>
                    <div class="thCol statusesCol">FOR RESPECTIVE STATUS</div>
                    <div class="thCol lockingCol">LOCKING PERIOD<br>(in days)</div>
                    <div class="thCol validityCol">ACTION VALIDITY<br>(in months)</div>
                </div>
                <div class="tableBody" formArrayName="actionConfigurations">
                    <div class="tableRow" *ngFor="let action of actionConfigs.controls; let i = index" [formGroupName]="i">
                        <div class="tdCol actionCol">
                            <label class="formLabel checkboxLabel" for="rememberMe">
                                <input type="checkbox" id="rememberMe" class="inputField"  formControlName="isEnabled">
                                <span class="styledCheckbox"></span>
                                {{ action.get('actionName')?.value }}
                            </label>
                        </div>
                        <div class="tdCol statusesCol">
                            <div class="statusChips">
                                <span 
                                    *ngFor="let status of statusOptions" 
                                    class="statusChip"
                                    [class.selected]="isStatusSelected(i, status)"
                                    (click)="toggleActionStatus(i, status)"
                                >
                                    {{ status }}
                                    <img *ngIf="isStatusSelected(i, status)" src="../../../../../assets/images/closeIcon-16x16.svg" alt="remove-status">
                                </span>
                                <button type="button" class="deselectBtn" (click)="deselectAllStatuses(i)">Deselect All</button>
                            </div>
                        </div>
                        <div class="tdCol lockingCol">
                            <select class="selectSmall" formControlName="lockingPeriod">
                                <option *ngFor="let period of lockingPeriodOptions" [value]="period">{{ period }}</option>
                            </select>
                        </div>
                        <div class="tdCol validityCol">
                            <select class="selectSmall" formControlName="actionValidity">
                                <option *ngFor="let validity of actionValidityOptions" [value]="validity">{{ validity }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Divider -->
        <hr class="sectionDivider">

        <!-- Section 4: Access Group Configuration -->
        <div class="formSection">
            <h2 class="sectionTitle">Access Group Configuration</h2>
            
            <!-- File Upload Area -->
            <div class="fileUploadArea">
                <div class="uploadBox" (click)="fileInput.click()">
                    <span class="uploadText">Drag and Drop or</span>
                    <span class="uploadLink">Upload Files from computer</span>
                    <input type="file" #fileInput (change)="onFileUpload($event)" accept=".csv,.xlsx" hidden>
                </div>
            </div>

            <!-- Access Groups List -->
            <div class="accessGroupsList" formArrayName="accessGroups">
                <div class="labelRow">
                    <label class="formLabel label required groupLabel">Add Access Group</label>
                    <label class="formLabel label required descLabel">Access Group Description</label>
                    <button type="button" class="clearAllBtn" (click)="clearAllAccessGroups()">Clear All</button>
                </div>
                <div class="accessGroupRow" *ngFor="let group of accessGroups.controls; let i = index" [formGroupName]="i">
                    <span class="rowNumber">{{ i + 1 }}.</span>
                    <input 
                        type="text" 
                        class="inputElement groupInput" 
                        formControlName="groupName" 
                        placeholder="Enter group name"
                    >
                    <input 
                        type="text" 
                        class="inputElement descInput" 
                        formControlName="groupDescription" 
                        placeholder="Enter description"
                    >
                    <button type="button" class="deleteRowBtn" (click)="removeAccessGroup(i)">
                        <img src="../../../../../assets/images/delete.svg" alt="delete">
                    </button>
                </div>
            </div>
            <div class="addRowSection">
                <span>Add more rows:</span>
                <input type="number" [(ngModel)]="accessGroupRowsToAdd" [ngModelOptions]="{standalone: true}" min="1" max="20" class="rowCountInput">
                <button type="button" class="addBtn" (click)="addMultipleAccessGroups()">ADD</button>
            </div>
        </div>

        <!-- Footer Actions -->
        <div class="formFooter">
            <button type="button" class="cancelBtn" (click)="onCancel()">Cancel</button>
            <div class="rightActions">
                <button type="button" class="resetBtn" (click)="onReset()">Reset</button>
                <button 
                    type="button" 
                    class="submitBtn" 
                    *ngIf="!isEditMode"
                    (click)="onSubmit()" 
                    [disabled]="!isFormValid()"
                >Submit</button>
                <button 
                    type="button" 
                    class="submitBtn" 
                    *ngIf="isEditMode"
                    (click)="onSaveChanges()" 
                    [disabled]="!isFormValid()"
                >Save Changes</button>
            </div>
        </div>
    </form>

    <!-- Cancel Confirmation Popup -->
    <div class="modal modal-backdrop" *ngIf="isCancelPopupVisible">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title">Are you sure?</div>
                    <img src="../../../../../assets/images/close_icon.svg" class="close_icon" (click)="closePopup()">
                </div>
                <div class="modal-body">
                    <p *ngIf="!isEditMode">
                        You are about to cancel new module creation. Once cancelled, all details will be deleted.
                        <br><br>
                        Do you want to proceed?
                    </p>
                    <p *ngIf="isEditMode">
                        You are about to cancel editing this module. Once cancelled, all unsaved changes will be lost.
                        <br><br>
                        Do you want to proceed?
                    </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="cancelBtn" (click)="closePopup()">No</button>
                    <button type="button" class="confirmBtn" (click)="confirmCancel()">Yes, continue</button>
                </div>
            </div>
        </div>
    </div>
</div>

